import React from 'react';

const BillingHistorySkeleton: React.FC = () => {
  return (
    <div className="space-y-4 px-1">
      <div className="flex items-center gap-3 h-10 mb-6">
        <div className="h-8 w-8 bg-gray-200 dark:bg-neutral-700 rounded-lg animate-pulse" />
        <div className="h-7 w-48 bg-gray-200 dark:bg-neutral-700 rounded-md animate-pulse" />
      </div>

      <div className="bg-white dark:bg-neutral-800 border border-gray-100 dark:border-neutral-700 rounded-xl overflow-hidden shadow-sm">
        <div className="h-14 bg-gray-50 dark:bg-neutral-800/50 border-b border-gray-100 dark:border-neutral-700 px-6 flex items-center gap-8">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-4 bg-gray-200/60 rounded animate-pulse flex-1" />
          ))}
        </div>
        <div className="divide-y divide-gray-50">
          {[...Array(10)].map((_, i) => (
            <div key={i} className="h-20 px-6 flex items-center gap-8">
              <div className="flex gap-3 items-center flex-1">
                <div className="h-10 w-10 bg-gray-100 dark:bg-neutral-600 rounded-xl animate-pulse flex-shrink-0" />
                <div className="space-y-2 flex-1">
                   <div className="h-4 w-3/4 bg-gray-100 dark:bg-neutral-600 rounded animate-pulse" />
                   <div className="h-3 w-1/2 bg-gray-50 dark:bg-neutral-800 rounded animate-pulse" />
                </div>
              </div>
              {[...Array(4)].map((_, j) => (
                <div key={j} className="h-4 bg-gray-100 dark:bg-neutral-600/80 rounded animate-pulse flex-1" />
              ))}
              <div className="h-9 w-28 bg-gray-100 dark:bg-neutral-600 rounded-xl animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BillingHistorySkeleton;
